import type React from 'react';
import { object, type AnySchema } from 'yup';
import { BaseReportElement } from '../BaseReportElement';
import type {
    BuildStructureSettingsYupSchemaHelpers,
    ContextForKind,
    ElementContentRenderResult,
    ElementSettings,
    RenderContextKind,
    RenderRuntime,
} from '../types';

export class PageBreakElement extends BaseReportElement<RenderContextKind, ElementSettings> {
    static readonly elementType = 'pagebreak';

    static readonly layout = { flow: 'fixed' } as const;

    static readonly compatibleContextKinds = ['project', 'measuring-point'] as const;

    static get insertion() {
        return {
            label: gettext('ELEMENT_PAGE_BREAK_LABEL'),
            supportedSlots: ['child-list'] as const,
            createDefinition: () => ({
                type: 'pagebreak',
                settings: {},
            }),
        };
    }

    static buildStructureSettingsYupSchema(
        _helpers: BuildStructureSettingsYupSchemaHelpers
    ): AnySchema {
        return object({}).required().noUnknown();
    }

    protected toCompatibleReactNode(
        _ctx: ContextForKind<RenderContextKind>,
        _runtime: RenderRuntime
    ): ElementContentRenderResult {
        return {
            node: (
                <div
                    aria-hidden
                    className="h-0"
                    style={{ breakAfter: 'page', pageBreakAfter: 'always' }}
                />
            ),
            ready: Promise.resolve(),
            hasRenderableContent: Promise.resolve(true),
        };
    }
}
